import { agileProcess, engineeringPractices, productManagementAndDevelopment, teamDynamics } from './question-sets';

export const trainAgileAssessment = {
  name: 'Team-Level Agile Assessment',
  key: 'team-level-agile-assessment',
  question_sets: [teamDynamics, productManagementAndDevelopment, agileProcess, engineeringPractices],
};

export default trainAgileAssessment;
